export enum BookStatusEnum {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
}
